import React, { useEffect, useState } from 'react';
import {
  Promo,
  Subscription,
  Likes,
  Comments,
  Social,
  PageMeta,
} from 'components';
import NotFoundPage from 'pages/404/404';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import {
  getArticle,
  getArticleIdle,
} from 'store/ducks/article/actions/articleActions';
import {
  getArticleList,
  getArticleListIdle,
} from 'store/ducks/article/actions/articleListActions';

import {
  articleSelector,
  articleListSelector,
} from 'store/ducks/article/selectors';
import { StateStatus } from 'types/models';
import cx from 'classnames';

import './Article.css';
import { getMetaField } from 'config';
import {
  selectPosition4Banner,
  selectPosition5Banner,
  selectPosition9Banner,
} from 'store/ducks/banners/selectors';
// import { getUser, getUserIdle } from 'store/ducks/users/actions';
import { Content } from './Components/content';
import { stat } from 'fs';
import Loader from 'components/Loader/Loader';
import { useIsDesktop } from '../../hooks';

type Props = {
  history?: any;
  location?: any;
  match?: {
    url: string;
  };
};

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: any;
  }
}

export default function Article(props: Props) {
  const data: any = useSelector(articleSelector);
  const dataArticleList: any = useSelector(articleListSelector);
  const [nextPostId, setNextPostId] = useState(null);
  const [dataSingle, setDataSingle] = useState(null);
  const [offsets, setOffsets] = useState([]);

  const isDesktop = useIsDesktop();

  const params: { slug: any } = useParams();
  const dispatch = useDispatch();
  const { status, statusArticleList } = useSelector(
    (state: {
      article: { status: StateStatus; statusArticleList: StateStatus };
    }) => state.article
  );

  let history = useHistory();

  const [articles, setArticles] = useState([]);
  const [statusNewPost, setStatusNewPost] = useState(false);

  const position4Banner = useSelector(selectPosition4Banner);
  const position5Banner = useSelector(selectPosition5Banner);
  const position9Banner = useSelector(selectPosition9Banner);

  const token = useSelector(
    (state: { userAuth: { token: boolean } }) => state.userAuth.token
  );

  const loadVideo = (id: any, item: any) => {
    let player = new window.YT.Player(id, {
      videoId: id,
      events: {
        onStateChange: (e: any) => {
          if (e.data == 1) {
            item.parentElement.classList.add('_play');
          } else if (e.data == 2) {
            item.parentElement.classList.remove('_play');
          }
        },
      },
    });
  };

  const nameSeparator = (username?: string) => {
    return isDesktop &&
      typeof username === 'string' &&
      username.split(' ').length === 2 ? (
      <br />
    ) : (
      ' '
    );
  };

  useEffect(() => {
    const links = document.querySelectorAll('.page-article__body a');
    if (links) {
      links.forEach(link => {
        const href = link.getAttribute('href');

        if (href && href.indexOf('ru.tophosts.net') > -1) {
          window.gtag &&
            window.gtag('event', 'link', {
              action: 'view',
              id: 'tophosts',
            });
          link.setAttribute('target', '_blank');
          link.addEventListener('click', () => {
            window.gtag &&
              window.gtag('event', 'link', {
                action: 'click',
                id: 'tophosts',
              });
          });
        } else if (href && href.indexOf('cloudvps.by') > -1) {
          window.gtag &&
            window.gtag('event', 'link', {
              action: 'view',
              id: 'cloudvps',
            });
          link.setAttribute('target', '_blank');
          link.addEventListener('click', () => {
            window.gtag &&
              window.gtag('event', 'link', {
                action: 'click',
                id: 'cloudvps',
              });
          });
        }
      });
    }
  }, []);

  useEffect(() => {
    if (status == 'IDLE') {
      dispatch(getArticle({ slug: params.slug }));
    }

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    setTimeout(function () {
      document.querySelectorAll('iframe').forEach(function (item) {
        if (!window.YT) {
          window.onYouTubeIframeAPIReady = loadVideo(
            item.getAttribute('id'),
            item
          );
        } else {
          loadVideo(item.getAttribute('id'), item);
        }
      });
    }, 1000);
    return () => {
      dispatch(getArticleIdle());
    };
  }, []);

  useEffect(() => {
    if (status == 'SUCCESS') {
      if (data) {
        setArticles([
          {
            path: data.path,
            slug: data.slug,
            next_post: {
              slug: (data.next_post && data.next_post.slug) || null,
            },
          },
        ]);
      }
      dispatch(getArticleIdle());
    }
  }, [status]);

  useEffect(() => {
    if (statusArticleList == 'SUCCESS') {
      setArticles([...articles, dataArticleList]);
      dispatch(getArticleListIdle());

      setTimeout(function () {
        document.querySelectorAll('iframe').forEach(function (item) {
          if (!window.YT) {
            window.onYouTubeIframeAPIReady = loadVideo(
              item.getAttribute('id'),
              item
            );
          } else {
            loadVideo(item.getAttribute('id'), item);
          }
        });
      }, 1000);
    }
  }, [statusArticleList]);

  useEffect(() => {
    let list: any = [];
    document.querySelectorAll('.page-article').forEach((item: any) => {
      list.push(window.scrollY + item.getBoundingClientRect().top);
    });
    setOffsets(list);
  }, [articles]);

  function setStatus(status: any) {
    setStatusNewPost(status);
  }

  const scrollHandler = (e: any) => {
    e.target.documentElement.scrollTop;

    if (
      articles[articles.length - 1] &&
      articles[articles.length - 1].next_post &&
      articles[articles.length - 1].next_post !== 0 &&
      e.target.documentElement.scrollHeight -
        (e.target.documentElement.scrollTop + window.innerHeight) <
        100
    ) {
      document.removeEventListener('scroll', scrollHandler);

      if (statusArticleList == 'IDLE') {
        if (articles[articles.length - 1].next_post.slug) {
          dispatch(
            getArticleList({
              slug: articles[articles.length - 1].next_post.slug,
            })
          );
        }
      }
    }
  };

  // window.history.pushState(
  //     null,
  //     null,
  //     `/${articles[articles.length - 1].path}/${articles[articles.length - 1].slug
  //     }`
  // );

  const setHistoryHash = (e: any) => {
    let activeArticle: any = null;
    let offsetsResult = offsets.filter((item, index) => window.scrollY > item);
    activeArticle = articles[offsetsResult.length - 1];
    if (activeArticle) {
      // history.push(`/${activeArticle.path}/${activeArticle.slug}`);
      // if (props.location.pathname !== '/' + activeArticle.path + '/' + activeArticle.slug){
      //     props.history.replace(`/${activeArticle.path}/${activeArticle.slug}`);
      // }
      window.history.replaceState(
        null,
        null,
        `/${activeArticle.path}/${activeArticle.slug}`
      );
    }
  };

  // window.onpopstate = function (event) {
  //     let pathArray = window.location.pathname.split('/');
  // }

  useEffect(() => {
    document.addEventListener('scroll', scrollHandler);
    document.addEventListener('scroll', setHistoryHash);

    return function () {
      document.removeEventListener('scroll', scrollHandler);
      document.removeEventListener('scroll', setHistoryHash);
    };
  }, [articles, data, offsets]);

  if (status == 'FAILURE') {
    return <NotFoundPage />;
  }

  return (
    <>
      <PageMeta
        title={(data.seo_title && data.seo_title) || data.title}
        description={
          (data.seo_description && data.seo_description) ||
          getMetaField('description', data.meta)
        }
        image={data.announce_img}
        url={`https://telesputnik.ru${props.match.url}`}
        canonical={`https://telesputnik.ru${data.link}`}
        status={data.status}
      />
      <main
        className={cx(
          'page page-article',
          data.type === 'video' && 'page-article--video',
          'container container--page',
          data.slug,
          status == 'LOADING' && '_loading'
        )}
        id={'page_' + data.key}
        data-index={`0`}
      >
        <input type="hidden" name="hash" value={`${data.path}/${data.slug}`} />
        <div className="article-header page-article__header--mobile">
          <div className={cx('article-header__left--full')}>
            <img
              className="article-header__img"
              src={data.announce_img}
              alt="img"
            />
          </div>
        </div>

        <div className="article-header page-article__header">
          {!articles.length && (
            <Loader show={status == 'LOADING' ? true : ''} />
          )}
          <div
            className={cx(
              'article-header__left',
              data.author === null && 'article-header__left--full'
            )}
          >
            <img
              className="article-header__img"
              src={data.announce_img}
              alt="img"
            />
            <span className="article-header__date">{data.date}</span>
            <h1
              className="article-header__title"
              dangerouslySetInnerHTML={{
                __html: data.title,
              }}
            />
            <ul className="article-header__list">
              {data.exclusive_material && (
                <li className="article-header__item">
                  <span className="tag article-header__tag">{'Эксклюзив'}</span>
                </li>
              )}
              {data.category && (
                <li className="article-header__item">
                  <Link to={'/materials/' + data.categorySlug}>
                    <span className="tag article-header__tag">
                      {data.category}
                    </span>
                  </Link>
                </li>
              )}

              {data.tags &&
                data.tags.length > 0 &&
                data.tags.map((tag: any, index: number) => (
                  <li key={index} className="article-header__item">
                    <Link to={'/tags/' + tag.slug}>
                      <span className="tag article-header__tag">
                        {tag.title}
                      </span>
                    </Link>
                  </li>
                ))}
            </ul>
            <p className="article-header__description">
              {data.announce_text && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: data.announce_text,
                  }}
                ></span>
              )}
            </p>
          </div>
          <div className={cx('article-header__right')}>
            <>
              {data.author && (
                <>
                  <div className="article-author article-header__author">
                    <div className="article-author__img">
                      {data.author.avatar ? (
                        <img src={data.author.avatar} alt="img" />
                      ) : data.author.username && data.author.surname ? (
                        <div>
                          {data.author.username[0]}
                          {data.author.surname[0]}
                        </div>
                      ) : null}
                    </div>
                    <div className="article-author__info">
                      <span className="article-author__title">
                        {data.author.username}
                        {nameSeparator(data.author.username)}
                        {data.author.surname}
                      </span>
                      <p className="article-author__description">
                        {data.author.profession}
                      </p>
                    </div>
                  </div>

                  {data.additional_authors &&
                    data.additional_authors.length > 0 && (
                      <div className="additional-authors">
                        {/*@ts-ignore*/}
                        {data.additional_authors
                          .slice(0, 3)
                          .map((additionalAuthor, index) => (
                            <div key={index} className="article-author">
                              <div className="article-author__img">
                                {additionalAuthor.avatar ? (
                                  <img
                                    src={additionalAuthor.avatar}
                                    alt="img"
                                  />
                                ) : (
                                  <div>
                                    {additionalAuthor.username[0]}
                                    {additionalAuthor.surname[0]}
                                  </div>
                                )}
                              </div>
                              <div className="article-author__info">
                                <span className="article-author__title">
                                  {additionalAuthor.username}
                                  {nameSeparator(additionalAuthor.username)}
                                  {additionalAuthor.surname}
                                </span>
                                <p className="article-author__description">
                                  {additionalAuthor.profession}
                                </p>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                </>
              )}
            </>
          </div>
        </div>
        <div className="page-article__author">
          {data.author && (
            <div className="article-author article-header__author">
              <div className="article-author__img">
                {data.author.avatar ? (
                  <img src={data.author.avatar} alt="img" />
                ) : data.author.username && data.author.surname ? (
                  <div>
                    {data.author.username[0]}
                    {data.author.surname[0]}
                  </div>
                ) : null}
              </div>
              <div className="article-author__info">
                <span className="article-author__title">
                  {data.author.username}
                  {nameSeparator(data.author.username)}
                  {data.author.surname}
                </span>
                <p className="article-author__description">
                  {data.author.profession}
                </p>
              </div>
            </div>
          )}
          {data.additional_authors && data.additional_authors.length > 0 && (
            <div className="additional-authors">
              {/*@ts-ignore*/}
              {data.additional_authors
                .slice(0, 3)
                .map((additionalAuthor, index) => (
                  <div key={index} className="article-author">
                    <div className="article-author__img">
                      {additionalAuthor.avatar ? (
                        <img src={additionalAuthor.avatar} alt="img" />
                      ) : (
                        <div>
                          {additionalAuthor.username[0]}
                          {additionalAuthor.surname[0]}
                        </div>
                      )}
                    </div>
                    <div className="article-author__info">
                      <span className="article-author__title">
                        {additionalAuthor.username}
                        {nameSeparator(additionalAuthor.username)}
                        {additionalAuthor.surname}
                      </span>
                      <p className="article-author__description">
                        {additionalAuthor.profession}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="page-article__description">
          {data.announce_text && (
            <span
              dangerouslySetInnerHTML={{
                __html: data.announce_text,
              }}
            ></span>
          )}
        </div>
        <div className="page-article__wrapper">
          <div className="page-article__body">
            {data.banner && (
              <div
                className="article-main page-article__banner"
                dangerouslySetInnerHTML={{
                  __html: data.banner,
                }}
              ></div>
            )}
            <div className="article-main page-article__main">
              <Content html={data.content} />
            </div>
            <div className="article-footer page-article__footer">
              <div className="article-footer__top">
                <Likes
                  postId={data.id}
                  like={data.like}
                  dislike={data.dislike}
                  type="article"
                />
                <Social
                  // url={window && window.location && location.href}
                  url={data.link}
                  text={data.announce_text}
                />
              </div>
              <div className="article-footer__middle">
                {(token && (
                  <Comments
                    postId={data.id}
                    key={data.slug}
                    // newPost=""
                    // setStatus=""
                    newPost={statusNewPost}
                    setStatus={setStatus}
                  />
                )) || (
                  <div className="article-footer__middle-comment">
                    Чтобы оставить комментарий необходимо{' '}
                    <Link to={`/authorization?post=${data.path}/${data.slug}`}>
                      авторизоваться
                    </Link>
                    .
                  </div>
                )}
              </div>
            </div>
          </div>
          <aside className="article-sidebar page-article__sidebar">
            {position4Banner && position4Banner.publications_hidden !== '*' && (
              <Promo
                type="article-page"
                img={position4Banner.img}
                tag=""
                link={position4Banner.url}
                html={position4Banner.html}
                id="position4Banner"
                target={'position4Banner_' + position4Banner.id}
              />
            )}
            <Subscription page="article-sidebar" mod="sidebar" />
          </aside>
        </div>
        <div className="article-others page-article__others">
          {/* <Media id={data.id} /> */}
          {position5Banner && position5Banner.publications_hidden !== '*' && (
            <Promo
              type="article-page"
              img={position5Banner.img}
              tag=""
              link={position5Banner.url}
              html={position5Banner.html}
              id="position5Banner"
              target={'position5Banner_' + position5Banner.id}
            />
          )}
          <Subscription mod="" page="article-others" />
        </div>
      </main>
      {articles &&
        articles.length > 0 &&
        articles.map((item, index) => {
          if (index > 0) {
            return (
              <div key={index}>
                <PageMeta
                  title={(item.seo_title && item.seo_title) || item.title}
                  description={
                    (item.seo_description && item.seo_description) ||
                    getMetaField('description', item.meta)
                  }
                  image={item.announce_img}
                />
                <main
                  key={item.key}
                  className={cx(
                    'page page-article',
                    item.type === 'video' && 'page-article--video',
                    'container container--page',
                    item.slug,
                    statusArticleList == 'LOADING' && '_loading'
                  )}
                  id={'page_' + item.key}
                  data-index={`${index}`}
                >
                  <input
                    type="hidden"
                    name="hash"
                    value={`${item.path}/${item.slug}`}
                  />
                  <div className="article-header page-article__header--mobile">
                    <div className={cx('article-header__left--full')}>
                      <img
                        className="article-header__img"
                        src={item.announce_img}
                        alt="img"
                      />
                    </div>
                  </div>
                  <div className="article-header page-article__header">
                    <div
                      className={cx(
                        'article-header__left',
                        item.author === null && 'article-header__left--full'
                      )}
                    >
                      <img
                        className="article-header__img"
                        src={item.announce_img}
                        alt="img"
                      />
                      <span className="article-header__date">{item.date}</span>
                      <h1
                        className="article-header__title"
                        dangerouslySetInnerHTML={{
                          __html: item.title,
                        }}
                      />
                      <ul className="article-header__list">
                        {item.category && (
                          <li className="article-header__item">
                            <Link to={'/materials/' + item.categorySlug}>
                              <span className="tag article-header__tag">
                                {item.category}
                              </span>
                            </Link>
                          </li>
                        )}
                        {item.tags &&
                          item.tags.length > 0 &&
                          item.tags.map((tag: any, index: number) => (
                            <li className="article-header__item" key={tag.id}>
                              <Link to={'/tags/' + tag.slug}>
                                <span className="tag article-header__tag">
                                  {tag.title}
                                </span>
                              </Link>
                            </li>
                          ))}
                      </ul>
                      <p className="article-header__description">
                        {item.announce_text && (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item.announce_text,
                            }}
                          ></span>
                        )}
                      </p>
                    </div>
                    <div className={cx('article-header__right')}>
                      {item.author && (
                        <div className="article-author article-header__author">
                          <div className="article-author__img">
                            <img src={item.author.avatar} alt="img" />
                          </div>
                          <div className="article-author__info">
                            <span className="article-author__title">
                              {item.author.surname} {item.author.username}
                            </span>
                            <p className="article-author__description">
                              {item.author.profession}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="page-article__wrapper clear-border">
                    <div className="page-article__body">
                      {item.banner && (
                        <div
                          className="article-main page-article__banner"
                          dangerouslySetInnerHTML={{
                            __html: item.banner,
                          }}
                        ></div>
                      )}
                      <div className="article-main page-article__main">
                        <Content html={item.content} />
                      </div>
                      <div className="article-footer page-article__footer">
                        <div className="article-footer__top">
                          <Likes
                            postId={item.id}
                            like={item.like}
                            dislike={item.dislike}
                            type="article"
                          />
                          <Social url={item.link} text={item.announce_text} />
                        </div>
                        <div className="article-footer__middle">
                          {(token && (
                            <Comments
                              postId={item.id}
                              key={item.slug}
                              newPost={statusNewPost}
                              setStatus={setStatus}
                            />
                          )) || (
                            <div className="article-footer__middle-comment">
                              Чтобы оставить комментарий необходимо{' '}
                              <Link
                                to={`/authorization?post=${item.path}/${item.slug}`}
                              >
                                авторизоваться
                              </Link>
                              .
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <aside className="article-sidebar page-article__sidebar">
                      {position4Banner &&
                        position4Banner.publications_hidden !== '*' && (
                          <Promo
                            type="article-page"
                            img={position4Banner.img}
                            tag=""
                            link={position4Banner.url}
                            html={position4Banner.html}
                            id="position4Banner"
                            target={'position4Banner_' + position4Banner.id}
                          />
                        )}
                      <Subscription page="article-sidebar" mod="sidebar" />
                    </aside>
                  </div>
                  <div className="clear"></div>
                  {/* <Media id={item.id} /> */}
                  {/* {position5Banner && (
                                            <Promo
                                                type="article-page"
                                                img={position5Banner.img}
                                                tag=""
                                                link={position5Banner.url}
                                                html={position5Banner.html}
                                                id="position5Banner"
                                            />
                                        )}
                                        <Subscription
                                            mod=""
                                            page="article-others"
                                        /> */}
                  {/* </div> */}
                </main>
              </div>
            );
          }
        })}
      <Loader show={statusArticleList == 'LOADING' ? true : ''} />
    </>
  );
}
